import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    ul: {
      listStyle: 'none',
      marginBottom: 0,
    },
    li: {
      '&::before': {
        content: '"•"',
        marginRight: 10,
      },
    },
    validLi: {
      color: '#029E0B',
    },
    invalidLi: {
      color: theme.palette.error.main,
      fontWeight: 'bold',
    },
    icon: {
      marginRight: 7,
      marginLeft: -6,
      position: 'relative',
      top: 2,
    },
  })
);
